import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: '1px',
    position: 'sticky',
    bottom: 0,
    zIndex: 20
  },
  container: {
    background: 'none',
    backgroundColor: 'none',
    borderRight: 'none'
  },
  totalItem: {
    width: 250
  }
}));

export default useStyles;
